import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ContactFormWrapper from '../components/ContactFormWrapper';
import { motion } from "framer-motion";

const DocumentsTranslationPage = () => {
  const { t } = useTranslation();

  return (

    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ px: 3, py: 5, maxWidth: '900px', mx: 'auto' }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#c6a04c' }}>
          ⚖️ {t("documents.title")}
        </Typography>

        <Typography variant="body1" paragraph>
          {t("documents.text")}
        </Typography>

        <List sx={{ pl: 2 }}>
          <ListItem sx={{ color: '#c6a04c' }}>- {t("documents.accounting.point1")}</ListItem>
          <ListItem sx={{ color: '#c6a04c' }}>- {t("documents.accounting.point2")}</ListItem>
          <ListItem sx={{ color: '#c6a04c' }}>- {t("documents.accounting.point3")}</ListItem>
          <ListItem sx={{ color: '#c6a04c' }}>- {t("documents.accounting.point4")}</ListItem>
        </List>

        <Box mt={4}>
          <ContactFormWrapper
            type="full"
            pageName="Juridik & Översättning"
            hideFields={['startDate', 'services', 'employees', 'previousSystem', 'businessStatus', 'requestedServices']}
            redirectPath="/"
            showHeader={false}
          />
        </Box>
      </Box>
    </motion.div>
  );
};

export default DocumentsTranslationPage;
